import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import {Checkbox, Col, Form, FormField, Row, Table} from "elemental-react16"
import {Button, Icon, Message, Image} from "semantic-ui-react"
import {withRouter} from "react-router"
import "style/CheckoutPage.scss"
import Price from "components/Price/Price"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import shop from "shop/shop"
import ProductTable from "components/Product/ProductTableReadOnly"
import track from "shop/track"
import DeliveryMessage from "components/Cart/DeliveryMessage"
import MinOrderFreeValue from "components/Cart/MinOrderFreeValue"
import MinOrderValue from "components/Cart/MinOrderValue"
import Responsive                                                from "react-responsive"
import Spinner                              from "components/Spinner/Spinner"
import htmr                                                                           from "htmr";

@withRouter
class ConfirmationPage extends Component {
	constructor() {
		super()
        this.state = {
			loadCart: true,
            show: false,
            cart: shop.cart,
            agb: false,
            privacy: false,
            confirmationStepActive: false,
            user    : "",
			password: "",
			guest: shop.session.shopuser.guest || "",
			form1Disabled: false,
			form2Disabled: true,
			form3Disabled: true,
			form4Disabled: true,
			form1Check: false,
			form2Check: false,
			form4Check: false,
			newcust: {
				firm: {
					name: "",
					uidnr: "",
					glnnr: "",
					customernumber: ""
				},
				person: {
					salutation: "",
					firstname: "",
					lastname: ""
				},
				address: {
					street: "",
					streetnumber: "",
					addition: "",
					postcode: "",
					city: "",
					country: "",
					deliverstreet: "",
					deliverstreetnumber: "",
					deliveraddition: "",
					deliverpostcode: "",
					delivercity: "",
					delivercountry: ""
				},
				contact: {
					email: "",
					phone: "",
					mobile: "",
					web: "",
					comment: ""
				},
				locale: "",
				deliveraddress: {
					streetnumber: "",
					street: "",
					addition: "",
					pcode: "",
					city: "",
					country: "",
					email: "",
					name1: "",
					name2: "",
					zusatz: "",
					phone: "",
					extras: {
						freecontact: "",
						addition: ""
					}
				},
                addressConfirmation: {
					streetnumber: "",
					street: "",
					addition: "",
					pcode: "",
					city: "",
					country: "",
					email: "",
					name1: "",
					name2: "",
					zusatz: "",
					phone: "",
					extras: {
						freecontact: "",
						addition: ""
					}
				}
			}
        }
		shop.cart.hooks.changed.add( this.update )
	}

	update = ( cart ) => {
		this.setState( {cart} )
	}

	updateCart = () => {
		let products = getProducts()
		products = getProducts()
		this.setState( { products } )
		this.forceUpdate()
	  }

	componentDidMount() {
		shop.cart.hydrate()
		shop.cart.hooks.changed.add( this.updateCart )
		track.checkout( {step: 3, products: shop.cart.products} )
		this.handleMountingAsync()
	}

	componentWillUnmount() {
		shop.cart.hooks.changed.remove( this.update )
	}

	handleEnquiry = async () => {

		let CartUser = shop.cart.getExtra( "CartUser" )
		let EmailUser = shop.cart.getExtra( "EmailUser" )
		if(CartUser == "" || !CartUser || CartUser == undefined || CartUser == null || EmailUser == "" || !EmailUser || EmailUser == undefined || EmailUser == null){
			shop.toast("Bitte überprüfen Sie Ihren Bestellernamen und E-Mail Adresse.")
			await new Promise(resolve => setTimeout(resolve, 500));
			this.props.history.push( "/checkout/delivery/" )
		}
		else{
			if(shop.register){
				shop.register.address.street = shop.register.address.street + ' ' + shop.register.address.streetnumber,
				shop.register.address.street1 = shop.register.address.street
				console.log("shop.register.HandleSubmit: ",shop.register)
				console.log("handleSubmit shop.register: ",shop.register)
				shop.cart.setExtra("shopRegister", shop.register)
				if(shop.register.contact.registerMe == true){
					try {
						await shop.fetch( `/shop/rest/service/request?id=customer_registration`, {
							method: "POST",
							body: JSON.stringify( shop.register )
						} )
						shop.session.shopuser.extras.guest = shop.session.shopuser.guest
						/*const delay = ms => new Promise(
							resolve => setTimeout(resolve, ms)
						  );
						await delay(2000);*/
		
						await shop.fetch( `/shop/rest/data/customertemp/update`, {
							method: "POST",
							credentials:"include",
							body: JSON.stringify({"title":shop.register.firm.name,
												"street":shop.register.address.street + ' ' + shop.register.address.streetnumber,
												"pcode":shop.register.address.postcode,
												"city":shop.register.address.city,
												"email":shop.register.contact.email})
						} )
					}
					catch (err) {
					console.log( err )
					shop.toast( err )
					}
				}
				
			}
			
	
			shop.cart.setExtra( "is_quotation_request", true )
			await new Promise(resolve => setTimeout(resolve, 800));
			console.log("handleEnquiry", shop.cart.data)
			this.props.history.push( "../success/" )
		}


	}

	handleMountingAsync = async () => {	
		//shop.cart.handleDeliverProcess()
		this.updateAboveMinFree()
	}



	handleSubmit = async () => {

		let CartUser = shop.cart.getExtra( "CartUser" )
		let EmailUser = shop.cart.getExtra( "EmailUser" )
		if(CartUser == "" || !CartUser || CartUser == undefined || CartUser == null || EmailUser == "" || !EmailUser || EmailUser == undefined || EmailUser == null){
			shop.toast("Bitte überprüfen Sie Ihren Bestellernamen und E-Mail Adresse.")
			await new Promise(resolve => setTimeout(resolve, 500));
			this.props.history.push( "/checkout/delivery/" )
		}
		else{
			if(shop.register){
				shop.register.address.street = shop.register.address.street + ' ' + shop.register.address.streetnumber,
				shop.register.address.street1 = shop.register.address.street
				console.log("shop.register.HandleSubmit: ",shop.register)
				console.log("handleSubmit shop.register: ",shop.register)
				shop.cart.setExtra("shopRegister", shop.register)
				if(shop.register.contact.registerMe == true){
					try {
						await shop.fetch( `/shop/rest/service/request?id=customer_registration`, {
							method: "POST",
							body: JSON.stringify( shop.register )
						} )
						shop.session.shopuser.extras.guest = shop.session.shopuser.guest
						/*const delay = ms => new Promise(
							resolve => setTimeout(resolve, ms)
						);
						await delay(2000);*/
		
						await shop.fetch( `/shop/rest/data/customertemp/update`, {
							method: "POST",
							credentials:"include",
							body: JSON.stringify({"title":shop.register.firm.name,
												"street":shop.register.address.street + ' ' + shop.register.address.streetnumber,
												"pcode":shop.register.address.postcode,
												"city":shop.register.address.city,
												"email":shop.register.contact.email})
						} )
					}
					catch (err) {
					console.log( err )
					shop.toast( err )
					}
				}
				
			}

			// MINDERMENGENZUSCHLAG UNTER 50 EUR
			/*const MIN_ORDER = shop.config.MIN_ORDER_PENALTY_VALUE
			const penaltyProduct = await shop.product( "N-WEB-MMZ" )

			if ( shop.cart.sum < MIN_ORDER ) {
				penaltyProduct.count = 1
				shop.cart.add( penaltyProduct )
			} else {
				shop.cart.remove( penaltyProduct )
			}*/
			
			shop.cart.setExtra( "is_quotation_request", false )
			await new Promise(resolve => setTimeout(resolve, 800));
			this.props.history.push( "../success/" )
		}
	}

	handleAgb = async ( agb, shipping ) => {
		console.log( `agb`, agb )
		this.setState( {agb} )
		await this.handleSetExtraShipping( shipping)
	}

	handleFracht = ( fracht ) => {
		console.log( `fracht`, fracht )
		this.setState( {fracht} )
	}

	handleDatenschutz = async ( privacy, shipping ) => {
		this.setState( {privacy} )
		await this.handleSetExtraShipping( shipping)
	}

	handleSetExtraShipping = async ( value ) => {
		await shop.cart.setExtra( "shipping", value )
		console.log("handleSetExtraShipping", value, shop.cart.data)
		if(!shop.cart.data.extras.DeliveryMessage || shop.cart.data.extras.DeliveryMessage == ""){
			shop.cart.handleDeliverProcess()
		}
	}  

	toHome = () => {
		this.props.history.push( "/home" )
	}

	updateAboveMinFree = () => {
		const { sum } = shop.cart.data
		const MIN_ORDER_FREE_VALUE = Number( shop.config.MIN_ORDER_FREE_VALUE ) || 0
		const pickup = shop.cart.data.extras.pickUp
		let aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || (Number(sum) > shop.config.MIN_ORDER_FREE_VALUE)
		if(shop.session && shop.session.shopuser){
			if (pickup) {
				aboveMinFree = true;
			} else {
				aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || 
				(Number(sum) >= shop.config.MIN_ORDER_FREE_VALUE) || 
				(shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.extras && 
					(shop.cart.data.deliveraddress.extras.lieferart == "EL" || 
					shop.cart.data.deliveraddress.extras.lieferart == "Abholung")) || 
				(Object.keys(shop.cart.data.deliveraddress).length === 0 && shop.session.value && shop.session.value.extras && 
					(shop.session.value.extras.lieferart == "EL" || 
					shop.session.value.extras.lieferart == "Abholung"));
			}
		}
		this.setState({ aboveMinFreeState: aboveMinFree })
	}

	render() {
		let {agb, privacy,fracht, aboveMinFreeState, loadCart} = this.state
		const { loading } = shop.cart
		//console.log("shop.cart",shop.cart, loading)
		if (loadCart) {
			setTimeout(() => {
				console.log("shop.cart",shop.cart, loading)
				this.setState({ loadCart: false });
			}, 500);
			return <div className="pa4 tc">
				<HeaderCheckout activeStep={2} />
				  <Spinner size="md" type="inverted"/></div>
		}
		console.log("shop.cart",shop.cart, loading)
		let manual_order_id = shop.cart.getExtra( "manual_order_id" )
		let referenceId = shop.cart.getExtra( "referenceId" )
		let attachments = shop.cart.getExtra( "attachments" )
		let CartUser = shop.cart.getExtra( "CartUser" )
		let EmailUser = shop.cart.getExtra( "EmailUser" )
		//console.log("manualorderid",shop.cart.data)
		let { deliveraddress, deliverdate} = shop.cart.data
		let comment = shop.cart.data.comment
		//console.log("shop.cart",shop.cart.data)
		let billingAddress = shop.session.value
		const {checkoutType} = this.props.match.params
		//console.log("checkoutType",this.props)
		const isRequest = !!checkoutType
		const canOrder = !agb || shop.cart.sum <= shop.config.MIN_ORDER_VALUE 
		const {hasDeliveryAddress} = shop.cart
		const hasTax = shop.config.taxRate
		let noCouponPrice = 0
		let { sum } = shop.cart.data
		const pickup = shop.cart.data.extras.pickUp
		const MIN_ORDER_VALUE = Number( shop.config.MIN_ORDER_VALUE ) || 0
		const MIN_ORDER_FREE_VALUE = Number( shop.config.MIN_ORDER_FREE_VALUE ) || 0
		const aboveMin = !shop.config.MIN_ORDER_VALUE || (Number(sum) > shop.config.MIN_ORDER_VALUE)
		//console.log("aboveMin",aboveMin, "sum",sum, "MIN_ORDER_VALUE",MIN_ORDER_VALUE)
		let aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || (Number(sum) > shop.config.MIN_ORDER_FREE_VALUE)
		console.log("shop.cart.data", shop.cart.data)

		if(shop.session && shop.session.shopuser){
			if (pickup) {
				aboveMinFree = true;
				shippingCosts = "0,00"
			} else if ( shop.cart.data.extras && shop.cart.data.extras.deliveryEL == "EL" ) {
				aboveMinFree = true;
				shippingCosts = "0,00"
			} else {
				aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || 
				(Number(sum) >= shop.config.MIN_ORDER_FREE_VALUE) || (shop.cart.data.extras && shop.cart.data.extras.deliveryTour && shop.cart.data.extras.deliveryTour !== "");
			}
				/*else {
				aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || 
				(Number(sum) >= shop.config.MIN_ORDER_FREE_VALUE) || 
				(shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.extras && shop.cart.data.deliveraddress.extras.tour &&
					(shop.cart.data.deliveraddress.extras.tour !== "" || 
					shop.cart.data.deliveraddress.extras.lieferart == "Abholung")) || 
				(Object.keys(shop.cart.data.deliveraddress).length === 0 && shop.session.value && shop.session.value.extras && shop.session.value.extras.tour &&
					(shop.session.value.extras.tour !== "" || 
					shop.session.value.extras.lieferart == "Abholung"));
				}*/
		}
		if(shop.cart.data.positions){
		  shop.cart.data.positions.map( position => {
			//console.log("noCouponPrice position",position)
			if(position.extras && (position.extras.couponPrice || position.extras.baseCustomerPrice)){
				const couponPrice = position.extras.couponPrice ? position.extras.couponPrice : position.extras.baseCustomerPrice;
				noCouponPrice += Number(parseFloat(couponPrice) * position.count * position.unit_multi);
			}
		  } )
		}
		console.log("shop.cart.data.deliveraddress",shop.cart.data)
		let shippingCosts = sum <= 100 ? "9,95" : (sum >= 150 ? "0,00" : "7,95");
		shippingCosts = aboveMinFree ? "0,00" : shippingCosts
		if(shop.session.shopuser && shop.session.shopuser.guest){
			shippingCosts = shop.cart.data.extras && shop.cart.data.extras.umkreis60 == "1" ? "0,00" : shippingCosts
		}
		console.log("shippingCosts",shippingCosts, parseFloat(shippingCosts.replace(",", ".")))
		const tax = (shop.cart.data.sum + parseFloat(shippingCosts.replace(",", ".")))  / 100 * Number( shop.config.taxRate )
		//console.log("deliveraddress: ",deliveraddress)
		if(!shop.session.value) return <div className="pa4 tc">HTTP 404</div>
		
		return (
			<div className="pb4">
				<HeaderCheckout activeStep={2} />
				{shop.session.shopuser && shop.session.shopuser.guest &&<div className="container ">
				{ <Link to={{
                pathname: "/checkout/customer/",
                search  : this.props.location.search
              }}>
                <Button
                  
                  primary>
                  {translate( "Ihre Daten bearbeiten" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>}
              <br/>
			  </div>}
				<div className="container ">
					{/*<Link to="/checkout/delivery"> <Button > <i className="icon-angle-left"/> Zurück </Button></Link>*/}
					<section>

						<div className="row-title tl">
							<h2>{translate("your data")}</h2>
						</div>

						<Responsive maxWidth={789}>
            <table>
				<colgroup>
					<col width="60%"/>
					<col width="50%"/>
				</colgroup>

              <tbody>
                <tr>
                  <td className="bb b--black-20 pb2 v-top">
                  <span className="black-50">{translate( "Rechnungsadresse" )} </span>
                  <div className="pt3">
                <strong> {billingAddress.title}</strong> <br/>
                {billingAddress.street} <br/>
                {billingAddress.pcode} {billingAddress.city}<br/>
                {billingAddress.country}<br/>
                {billingAddress.email && <div>{billingAddress.email}</div>}
                {billingAddress.phone && <div>{billingAddress.phone}</div>}
                {/*billingAddress.extras && billingAddress.extras.bemerkung && billingAddress.extras.bemerkung != "" && <div>{billingAddress.extras.bemerkung}</div>*/}
              </div>
                    </td>
                  <td className="bb b--black-20 pb2 v-top">
                  <span className="black-50">{translate( "Lieferadresse" )} </span>
				  <div className="pt3">
									{!hasDeliveryAddress &&  !pickup && <div className={"b"}>{translate( "Rechnungsadresse" )}</div>}
									{pickup && <div className="b">{translate( "Abholung" )}</div>}
									{deliveraddress && !pickup && <div>
									<div className="mb4">
										<strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
										{deliveraddress.street}<br/>
										{deliveraddress.pcode} {deliveraddress.city}<br/>
										{deliveraddress.country}<br/>
										<div className="pt3 f6">
										{deliveraddress.email && <div>{deliveraddress.email}</div>}
										{deliveraddress.phone && <div>Tel.: {deliveraddress.phone}</div>}
										{deliveraddress.extras && deliveraddress.extras.bemerkung && deliveraddress.extras.bemerkung != '' && <div>Bemerkung: {htmr(deliveraddress.extras.bemerkung)}</div> }
										</div>
									</div>
									</div>}
								</div>
                    </td>
                </tr>
                <tr>
                  <td className="pt3">
                  <span className="black-50">{translate("payment")}</span>
                    </td>
                    <td className="pl2 pt3">
                    <span className="black-50">{translate("your comment")}</span>
                    </td>
                </tr>
                <tr>
                  <td className="pt3 pb3 bb b--black-20 v-top">
                  <strong>{shop.session.value.extras.zahlartext}</strong>
                  </td>
                  <td className="pl2 pt3 pb3 bb b--black-20 v-top">
                  <strong>{comment ? comment : "-"}</strong>
                  </td>
                </tr>
				<tr>
                  <td className="pt3">
                  <span className="black-50">{translate("Bestellername")}</span>
                    </td>
                    <td className="pl2 pt3">
                    <span className="black-50">{translate("E-mail Adresse")}</span>
                    </td>
                </tr>
                <tr>
                  <td className="pt3 pb3 bb b--black-20 v-top">
                  <strong>{CartUser}</strong>
                  </td>
                  <td className="pl2 pt3 pb3 bb b--black-20 v-top">
                  <strong>{EmailUser}</strong>
                  </td>
                </tr>
                </tbody>
            </table>
            {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <table>
              <tbody>
                <tr>
                  <td>
                  <div  className="justify-between bg-white pa3 VariantsPullDownCart ">
                <div className="pb3 black-40">{translate("Ihr aktueller Bestellwert: ")}<Price>{sum}</Price><br/></div>
                <table className="pb3">
                <colgroup>
                    <col width="85%"/>
                    <col width="15%"/>
                </colgroup>
                <tbody>
                    <tr>
                    <td>
                        {!aboveMinFree && !pickup && <div className="pb2 b">{translate("Kostenloser Versand erreicht in: ")}</div>}
                        {!aboveMinFree && !pickup && <div className="pb2 b">{translate("Lieferkosten: ")}</div>}
						{(aboveMinFree || aboveMinFreeState) && <div className="pb2 b">{translate("Kostenloser Versand erreicht!")}</div>}
                    </td>
                    <td className="b tr">
                        {!aboveMinFree && !pickup && <Price>{MIN_ORDER_FREE_VALUE-sum}</Price>}<br/>
                        {!aboveMinFree && !pickup && <Fragment>{shippingCosts} &nbsp;EUR</Fragment>}</td>
                    </tr>
                    <tr>
                    <td>{!aboveMinFree && !pickup && <MinOrderFreeValue sum={sum} />}</td>
                    </tr>
                </tbody>    
                </table>

                <table>
                <colgroup>
                    <col width="15%"/>
                    <col width="70%"/>
                    <col width="15%"/>
                </colgroup>
                <tbody>
                    <tr>
                    <td>
                        <Image className="w-40 h-40" src={`/arrowdownright.png`}/>
                        </td>
                    <td>
                        {!aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht in: ")}</div>}
                        {aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht!")} </div>}
                    </td>
                    <td className="b tr">
                        {!aboveMin && <Price>{MIN_ORDER_VALUE-sum}</Price>}</td>
                    </tr>
                    <tr>
                        <td></td>
                    <td>{!aboveMin && <MinOrderValue sum={sum} />}</td>
                    </tr>
                </tbody>    
                </table>
            </div>
                  </td>
                </tr>
              </tbody>
            </table>}
              {/*<div className="pt3">
                {!hasDeliveryAddress && !pickup && <div className={"b"}>{translate( "Rechnungsadresse" )}</div>}
                {pickup && <div className="b">{translate( "Abholung" )}</div>}
                {deliveraddress && !pickup && <div>
                  <div className="mb4">
                    <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                    {deliveraddress.street}<br/>
                    {deliveraddress.pcode} {deliveraddress.city}<br/>
                    {deliveraddress.country}<br/>
                    <div className="pt3 f6">
                      {deliveraddress.email && <div>{deliveraddress.email}</div>}
                      {deliveraddress.phone && <div>Tel.: {deliveraddress.phone}</div>}
                      {deliveraddress.extras && deliveraddress.extras.bemerkung && deliveraddress.extras.bemerkung != '' && <div>Bemerkung: {deliveraddress.extras.bemerkung}</div> }
                    </div>
                  </div>
                </div>}
              </div>*/}
            </Responsive>
			<Responsive minWidth={790}>
						<div className="pb3">
							<Row>
								{(manual_order_id !== undefined) &&
								<Col md="1/5" className=""><span className="black-50">{translate("manual_order_id")}</span>
									<div className="pt3">
										<p className="mb4">{manual_order_id}</p>
									</div>
								</Col>}
								<Col md="1/5" className=""><span className="black-50">{translate("Rechnungsadresse")} </span>
									{billingAddress.title != "Guest" &&<div className="pt3">
										<strong> {billingAddress.title}</strong> <br/>
										{billingAddress.street} <br/>
										{billingAddress.pcode} {billingAddress.city}<br/>
										{billingAddress.country}<br/><br/>
										<p className="f5 black-60">{translate("Bestellername")}: {CartUser}<br/>
										{translate("E-mail Adresse")}: {EmailUser}<br/></p>
									</div>}
								</Col>
								<Col md="1/5" className=""><span className="black-50">{translate( "Lieferadresse" )} </span>
								<div className="pt3">
									{!hasDeliveryAddress && !pickup && <div className={"b"}>{translate( "Rechnungsadresse" )}</div>}
									{pickup && <div className="b">{translate( "Abholung" )}</div>}
									{deliveraddress && !pickup && <div>
									<div className="mb4">
										<strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
										{deliveraddress.street}<br/>
										{deliveraddress.pcode} {deliveraddress.city}<br/>
										{deliveraddress.country}<br/>
										<div className="pt3 f6">
										{deliveraddress.email && <div>{deliveraddress.email}</div>}
										{deliveraddress.phone && <div>Tel.: {deliveraddress.phone}</div>}
										{deliveraddress.extras && deliveraddress.extras.bemerkung && deliveraddress.extras.bemerkung != '' && <div>Bemerkung: {htmr(deliveraddress.extras.bemerkung)}</div> }
										</div>
									</div>
									</div>}
								</div>
								</Col>
								<Col md="1/5" className=""><span className="black-50">{translate("payment")}</span>
									<div className="pt3 pb2">
										{/*<Link className={"mr3"} to={"/cms/zahlungsbedingungen-2024/"}>
										<strong>{translate("Zahlung auf Rechnung")}</strong>
												</Link>*/}
										<strong>{shop.session.value.extras.zahlartext}</strong>
									</div>
									<div className="pt3 bt b--black-20">
										<span className="black-50">{translate("your comment")}</span>
											<div className="pt3">
												<strong>{comment ? comment : "-"}</strong>
											</div>
										
									</div>
								</Col>
								{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Col md="2/5" className=""><span className="black-50 pb2">{translate( "Lieferhinweise" )} </span>
									<div  className="justify-between bg-white pa3 VariantsPullDownCart ">
										<div className="pb3 black-40">{translate("Ihr aktueller Bestellwert: ")}<Price>{sum}</Price><br/></div>
										<table className="pb3">
										<colgroup>
											<col width="85%"/>
											<col width="15%"/>
										</colgroup>
										<tbody>
											<tr>
											<td>
												{!aboveMinFree && !pickup && <div className="pb2 b">{translate("Kostenloser Versand erreicht in: ")}</div>}
												{!aboveMinFree && !pickup && <div className="pb2 b">{translate("Lieferkosten: ")}</div>}
												{(aboveMinFree || pickup) && <div className="pb2 b">{translate("Kostenloser Versand erreicht!")}</div>}
											</td>
											<td className="b tr">
												{!aboveMinFree && !pickup && <Price>{MIN_ORDER_FREE_VALUE-sum}</Price>}<br/>
												{!aboveMinFree && !pickup && <Fragment>{shippingCosts} &nbsp;EUR</Fragment>}</td>
											</tr>
											<tr>
											<td>{!aboveMinFree && !pickup && <MinOrderFreeValue sum={sum} />}</td>
											</tr>
										</tbody>    
										</table>

										<table>
										<colgroup>
											<col width="15%"/>
											<col width="70%"/>
											<col width="15%"/>
										</colgroup>
										<tbody>
											<tr>
											<td>
												<Image className="w-40 h-40" src={`/arrowdownright.png`}/>
												</td>
											<td>
												{!aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht in: ")}</div>}
												{aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht!")} </div>}
											</td>
											<td className="b tr">
												{!aboveMin && <Price>{MIN_ORDER_VALUE-sum}</Price>}</td>
											</tr>
											<tr>
												<td></td>
											<td>{!aboveMin && <MinOrderValue sum={sum} />}</td>
											</tr>
										</tbody>    
										</table>
									</div>
								
								</Col>}
								<Col md="1/5" className=""></Col>


								{deliverdate &&
								<Col md="1/5" className=""><span className="black-50">{translate("delivery after")}
									<div className="pt3">
						<p className="mb4">{deliverdate}</p>
						</div>
						</span></Col>}

							</Row>
						</div>
						</Responsive>
						</section>

					<section>

						{attachments && <Row>
							<Col>
								<div className="row-title tl">
									<h2>{translate( "attachments" )}</h2>
								</div>
								<p><strong>Logo ID</strong>: {attachments}</p>
							</Col>
						</Row>}
					</section>

					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <DeliveryMessage />}


					<section className="overflow-hidden pt3">
						<div className="row-title tl">
							<h2>{translate( "order items" )}</h2>
						</div>

						<ProductTable cart={shop.cart} onChange={this.handleChange} products={getProducts()} />
						{shop.session && shop.session.shopuser && shop.session.shopuser.guest && <Table style={{maxWidth: "320px"}} className="fr">
							<thead>

							</thead>
							<tbody>
							{<tr>
								<td><span className="f5 b black">{translate( "Versandkosten" )}</span></td>
								<td className="f5 b  tr"><Price>{parseFloat(shippingCosts.replace(",", "."))}</Price></td>
							</tr>}
							</tbody>
						</Table>}
						
						{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Table style={{maxWidth: "320px"}} className="fr">
							<thead>

							<tr>
								<td className="tr" colSpan="2">
									<span className="black-50 f5"><strong>{shop.cart.size} {translate( "positions" )} </strong></span>
								</td>
							</tr>
							{console.log("noCouponPrice",noCouponPrice, shop.cart)}
							{!shop.activeCoupons && <tr>
								<td><span className="f4 b black">{translate( "SummeOhneSteuer" )}</span></td>
								<td className="f4 b black tr"><Price>{shop.cart.data.sum}</Price></td>
							</tr>}
							{shop.activeCoupons && shop.activeCoupons[0] && <tr>
								<td><span className="f4 b black">{translate( "SummeOhneSteuer" )}</span></td>
								<td className="f4 b  tr"><div className="f6 strike black-60"><Price>{Number(noCouponPrice)}</Price></div>
								<div className="red fw7"><Price>{shop.cart.data.sum}</Price></div></td>
							</tr>}


							{/* DISCOUNTS!*/}
							{(shop.session.handId && !!shop.cart.sumDiscount) &&
							<React.Fragment>
								<tr className={"black-60 f5"}>
									<td>{translate( "Discount" )}</td>
									<td className="tr"><Price>{shop.cart.sumDiscount}</Price></td>
								</tr>

								<tr>
									<td><strong>{translate( "nach Rabatt" )}</strong></td>
									<td className="tr"><Price>{shop.cart.data.sum - shop.cart.sumDiscount}</Price></td>
								</tr>
							</React.Fragment>
							}

							</thead>
							<tbody>
							{ <tr>
								<td><span className="f5 b black">{translate( "inkl. Versandkosten" )}</span></td>
								<td className="f5 b  tr"><Price>{parseFloat(shippingCosts.replace(",", ".")) + shop.cart.data.sum}</Price></td>
							</tr>}
							{hasTax && <tr>
								<td><span className="f5  ">{translate( "zzgl. Steuern" )} ({shop.config.taxRate.replace( ".", "," )}%)</span></td>
								<td className="f5   tr"><Price>{tax}</Price></td>
							</tr>}

							{hasTax && <tr>
								<td><span className="f5 b black">{translate( "inkl. Steuern" )}</span></td>
								<td className="f5 b  tr"><Price>{Number(tax) + Number(shop.cart.data.sum) + parseFloat(shippingCosts.replace(",", "."))}</Price></td>
							</tr>}
							</tbody>
						</Table>}
					</section>
					{/*<section>*/}
					{/*	<div className="mv3">*/}
					{/*		<WordPressContainer*/}
					{/*			className={"ui message mb3"}*/}
					{/*			slug={"confirmation-notice"} postType={"shop"} />*/}
					{/*	</div>*/}
					{/*</section>*/}
					<section>
						<div className="row-title tl pt2">
							<h2>{translate( "Abschluss" )}</h2>
						</div>

						<div className="tr">
							<Form type="horizontal">

								<FormField>

									{!privacy && <div className="cf dib pb2">
										<Message negative className="">
											<div className="total ">
												<div className="ph3">
													<Icon name="info" />{translate( "please confirm our privacy information" )}
												</div>
											</div>
										</Message>
									</div>}

									<div className="tr"><Link target="_blank"
															  to="/cms/datenschutz">{translate( "Datenschutzerklärung" )}</Link><br />
									</div>
									<Checkbox value={privacy}
											  onChange={( e ) => this.handleDatenschutz( e.target.checked, parseFloat(shippingCosts.replace(",", ".")) )}
											  label={translate( "privacy_notice_notice" )} />
								</FormField>

								{/*<FormField>
									{!fracht && <div className="cf dib pb2">
										<Message negative className="">
											<div className="total ">
												<div className="ph3">
													<Icon name="info" />{translate( "Bitte bestätigen Sie unsere Frachtkosten" )}
												</div>
											</div>
										</Message>
									</div>}

									<div className="tr"><Link target="_blank"
															  to="/account">{translate( "Frachtkosten" )}</Link><br /></div>
									<Checkbox value={fracht} onChange={( e ) => this.handleFracht( e.target.checked )}
											  label={translate( "Ich habe die Frachtkosten gelesen und akzeptiert" )} />
								</FormField>*/}

								<FormField>
									{!agb && <div className="cf dib pb2">
										<Message negative className="">
											<div className="total ">
												<div className="ph3">
													<Icon name="info" />{translate( "please confirm our general terms" )}
												</div>
											</div>
										</Message>
									</div>}

									<div className="tr"><Link target="_blank"
															  to="/cms/agb">{translate( "AGB" )}</Link><br /></div>
									<Checkbox value={agb} onChange={( e ) => this.handleAgb( e.target.checked, parseFloat(shippingCosts.replace(",", ".")) )}
											  label={translate( "I accept the general terms and conditions" )} />
								</FormField>
							</Form>
						</div>

						{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && shop.cart.sum <= shop.config.MIN_ORDER_VALUE &&
						<div className="cf pb2">
							<Message negative className="">
								<div className="total ">
									<div className="ph3">
										<Icon name="info" />{translate( "minimum order value not reached" )}
										<span className="pull-right">
                    						<Price>{shop.config.MIN_ORDER_VALUE}</Price>
								     </span>
									</div>
								</div>
								
							</Message>
						</div>
						}
						{shop.cart.sum <= shop.config.MIN_ORDER_VALUE && !isRequest &&
						<Link to="/home">
							<Button
								className="fl"
								primary
								style={{
									paddingLeft : "32px",
									paddingRight: "32px"
								}}>{translate( "Zurück zum Shop" )}
							</Button>
						</Link>}
						{!isRequest && shop.session && shop.session.shopuser && !shop.session.shopuser.guest && 
						<Button
							className="fr"
							disabled={canOrder}
							primary
							onClick={this.handleSubmit}
							style={{
								paddingLeft : "32px",
								paddingRight: "32px"
							}}>{translate( "order now" )}</Button>}
						{shop.session &&
						<Button
							className="fr"
							primary
							disabled={privacy && agb ? false : true}
							onClick={this.handleEnquiry}
							style={{
								paddingLeft : "32px",
								paddingRight: "32px"
							}}>{translate( "send enquiry" )}</Button>}
					</section>
				</div>
			</div>

		)
	}
}

const getProducts = () => shop.cart.map( ( product ) => product )
export default ConfirmationPage



// WEBPACK FOOTER //
// ./src/theme/hvz/pages/checkout/ConfirmationPage.js